var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.333,
    viewBox: "0 0 12 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_\\u66F8\\u985E",
    d: "M7.644,5.428H3.275a.325.325,0,0,1,0-.651H7.644a.325.325,0,1,1,0,.651M5.183,3.62a.325.325,0,0,0-.325-.325H3.275a.325.325,0,0,0,0,.651H4.857a.325.325,0,0,0,.325-.325m0,6.67a.325.325,0,0,0-.325-.325H3.275a.325.325,0,1,0,0,.651H4.857a.325.325,0,0,0,.325-.325M7.338,6.532a.325.325,0,0,0-.325-.325H3.275a.325.325,0,0,0,0,.651H7.013a.325.325,0,0,0,.325-.325m.631,1.41a.325.325,0,0,0-.325-.325H3.275a.325.325,0,0,0,0,.651H7.644a.325.325,0,0,0,.325-.325M12,3.735v9.273a.325.325,0,0,1-.325.325H.325A.325.325,0,0,1,0,13.007V.325A.325.325,0,0,1,.325,0H8.793a.335.335,0,0,1,.061.006h0a.323.323,0,0,1,.077.028l.019.01A.33.33,0,0,1,9.023.1l2.849,3.338A.324.324,0,0,1,12,3.692a.31.31,0,0,1,0,.043M9.13,1.123l-.013-.013V3.366h1.767Zm2.215,11.558V4.017H8.793a.325.325,0,0,1-.325-.325V.651H.651V12.682Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.29c0ea3ad16c9746ed8f557a494af6d9.svg";
export { ForwardRef as ReactComponent };